var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDemandBookActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24.004,
    height: 24,
    rx: 4,
    fill: "#BE1E3B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 5H8a1 1 0 0 0-1 1v13l5-2.527L17 19V6a1 1 0 0 0-1-1z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemandBookActiveIcon);
export default __webpack_public_path__ + "static/media/demandBookActiveIcon.0f54690a12336cc72efd23c3cd830350.svg";
export { ForwardRef as ReactComponent };